(function () {
// --- Guard: only run if required elements exist ---
const getIdea = document.getElementById("get_idea");
const container = document.querySelector(".article-default-container");
const mailingWrap = document.querySelector(".mailing-list-wrapper");
const mainContent = document.querySelector(".main-content-wrapper__article-revamp");

if (!getIdea || !container || !mailingWrap || !mainContent) return;

// Fixed header height (adjust to match your navbar)
// Tip: if your header height changes (shrink), you can make this dynamic later.
const HEADER_OFFSET = 122;

// --- Helpers ---
// Get element top position relative to the document (not the viewport)
function docTop(el) {
    const r = el.getBoundingClientRect();
    return r.top + window.pageYOffset;
}

// Sync left and width when fixed to prevent horizontal jump
function syncFixedGeometry() {
    const wrapRect = mailingWrap.getBoundingClientRect();
    getIdea.style.setProperty("--fixed-left", `${wrapRect.left}px`);
    getIdea.style.setProperty("--fixed-width", `${wrapRect.width}px`);
    getIdea.style.setProperty("--fixed-top", `${HEADER_OFFSET}px`);
}

// Core update logic (decides between normal / fixed / stuck states)
function update() {
    const scrollY = window.pageYOffset;

    // Start fixing the card when the main content reaches the header offset
    const startFixY = docTop(mainContent) - HEADER_OFFSET;

    // Stop fixing when the card reaches the bottom boundary of the container
    const containerTop = docTop(container);
    const containerBottom = containerTop + container.offsetHeight;
    const ideaHeight = getIdea.offsetHeight;

    const endFixY = containerBottom - HEADER_OFFSET - ideaHeight;

    // Reset states
    getIdea.classList.remove("is-fixed", "is-stuck");

    if (scrollY < startFixY) {
    // Before entering the article content area: normal positioning
    return;
    }

    if (scrollY >= startFixY && scrollY <= endFixY) {
    // Within the content range: fixed below the header
    syncFixedGeometry();
    getIdea.classList.add("is-fixed");
    return;
    }

    // After the content range: lock the card to the bottom of the wrapper
    getIdea.classList.add("is-stuck");
}

// --- Performance: throttle scroll via requestAnimationFrame ---
let ticking = false;

function requestUpdate() {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(() => {
    update();
    ticking = false;
    });
}

// Events
window.addEventListener("scroll", requestUpdate, { passive: true });
window.addEventListener("resize", () => {
    // Re-sync geometry on resize (important for responsive layouts)
    if (getIdea.classList.contains("is-fixed")) syncFixedGeometry();
    requestUpdate();
});

// Initial run
update();
})();